// @ actions
const notification = require('actions/notifications');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { formatText } = require('core/i18n').i18n;
// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
// @ constants
const actionTypes = require('constants/actionTypes');
const { FILTERS_VALID, FILTERS_INVALID, REQUESTED_LIST_ACCOUNTS } = require('constants/index');

function requestAccountAlias(accountId, alias) {
    return {
        type: actionTypes.SET_ACCOUNT_ALIAS_REQUEST,
        payload: {
            accountId,
            alias
        }
    };
}

function setAccountAliasSuccess(accountId, alias) {
    return {
        type: actionTypes.SET_ACCOUNT_ALIAS_SUCCESS,
        payload: {
            accountId,
            alias
        }
    };
}

function setAccountAliasFailure(accountId) {
    return {
        type: actionTypes.SET_ACCOUNT_ALIAS_FAILURE,
        payload: {
            accountId
        }
    };
}

function setAccountAlias(dispatch, getState, accountId, alias) {
    dispatch(requestAccountAlias(accountId, alias));

    const account = getState().accounts.get('byId').get(accountId);
    const validFilter = account.get('filters').get('valid') ? FILTERS_VALID : FILTERS_INVALID;
    const accountsRequestData = {
        query: {
            listaCuentas: {
                cuentas: [
                    {
                        cnuevo: {
                            numerodecontrato: account.get('newContractNumber'),
                            producto: account.get('newProduct')
                        },
                        cviejo: {
                            numerodecontrato: account.get('contractNumber'),
                            subgrupo: account.get('product')
                        },
                        descripcion: account.get('alias'),
                        descripcionPersonalizada: alias,
                        filtroValido: validFilter,
                        filtroValidoPersonalizado: validFilter
                    }
                ]
            },
            listaSolicitada: REQUESTED_LIST_ACCOUNTS
        }
    };

    APIPost(dispatch, apiURLBuilder.getURL('setCustomProfileEditSettings'), accountsRequestData)
        .then(function() {
                const message = formatText('myMoneyTransactions-editAliasSuccess');

                dispatch(notification.success({message}, {voice: message}));
                dispatch(setAccountAliasSuccess(accountId, alias));
            },
            function() {
                const message = formatText('myMoneyTransactions-editAliasError');

                dispatch(notification.error({message}, {voice: message}));
                dispatch(setAccountAliasFailure(accountId));
            }
        );
}

function postAccountAlias(accountId,  alias) {
    return function(dispatch, getState) {
        setAccountAlias(dispatch, getState, accountId, alias);
    }
}

module.exports = {
  postAccountAlias
};
